import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { AxiosPromise } from 'axios';

export class InformeGraficoService {
  axios: AxiosVue;

  constructor() {
    this.axios = new AxiosVue(ServicioProxy.Metabase);
  }

  getDataTemperatura(body: any): AxiosPromise {
    return this.axios.http.post(
      'Metabase/PostgenericA/temperatura/getDataGraph',
      body
    );
  }


}
